<template>
  <div class="bg-layer" :class="[ 'bg-layer-' + variant ]" v-if="visible">
    <template v-if="ticket === 'basic'">
      <span>ご利用になるには、いずれかのプランにお申し込みください。</span>
    </template>
    <template v-if="ticket === 'premium'">
      <span>プレミアム版限定の機能です。</span>
    </template>
  </div>
</template>

<script>
module.exports = {
  props: [
    'ticket',
    'variant'
  ],
  data: function () {
    return { };
  },
  computed: {
    visible () {
      if (this.ticket === 'basic' && [ 'trial', 'basic', 'premium',  ].indexOf(this.$store.state.auth.ticket) >= 0) {
        return false
      }
      if (this.ticket === 'premium' && [ 'trial', 'premium',  ].indexOf(this.$store.state.auth.ticket) >= 0) {
        return false
      }
      return true
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.bg-layer {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 1em;
  padding-top: 5em;

  &.bg-layer-light {
    background: rgba(255, 255, 255, 0.8);
    color: #343a40;
  }

  &.bg-layer-dark {
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
  }

  &.bg-layer-white {
    background: rgba(255, 255, 255, 0.98);
    color: #343a40;
  }
}
.bg-layer * {
  -ms-user-select: none; /* IE 10+ */
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>
